import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Products from './components/Products';
import Galeria from './components/Galeria';
import VideoSection from './components/VideoSection';
import MisionVision from './components/MisionVision';
import Facturacion from './components/Facturacion';
import Ferreteria from './components/Ferreteria';
import About from './components/About';
import WhyUs from './components/WhyUs';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppFloat from './components/WhatsAppFloat';

function App() {
  return (
    <div className="app">
      <Navbar />
      <Hero />
      <Products />
      <Galeria />
      <Ferreteria />
      <About />
      <MisionVision />
      <VideoSection />
      <WhyUs />
      <Facturacion />
      <Contact />
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}

export default App;
